import * as Sentry from '@sentry/react'
import { clientesBack } from '../common/api/https'

export const getSession = async (params) => {
  try {
    const { uuid } = params

    const res = await clientesBack.get('/v1/login/share-session', {
      params: { uuid },
    })

    const raw = res.data || {}

    if (!raw.SE_INFO || !raw.SE_CONTRATO || !raw.SE_TOKEN) {
      return {
        code: 401,
        message: 'Información de sesión incompleta',
        payload: raw,
        authValid: false,
        errorCode: 'INCOMPLETE_SESSION_INFO',
      }
    }

    const k = raw?.SE_INFO?.keycloak_token ?? {}

    if (!k.access_token || !k.refresh_token) {
      return {
        code: 401,
        message: 'Tokens de autenticación incompletos',
        payload: { SE_INFO: raw.SE_INFO },
        authValid: false,
        errorCode: 'INCOMPLETE_AUTH_TOKENS',
      }
    }

    return {
      code: res.status,
      authValid: true,
      data: {
        userToken: raw.SE_TOKEN,
        accessToken: k.access_token,
        refreshToken: k.refresh_token,
        expiresIn: Number(k.expires_in || 300),
        refreshExpiresIn: Number(k.refresh_expires_in || 1800),
        emailUsuario: raw.SE_INFO?.email,
        idUsuario: raw.SE_IDUSUARIO,
        contrato: raw.SE_CONTRATO,
      },
    }
  } catch (e) {
    const status = e?.response?.status ?? 0
    const responseData = e?.response?.data || {}
    const isServerSide = status === 0 || status >= 500

    if (isServerSide) {
      Sentry.withScope((scope) => {
        scope.setTag('service', 'CLIENTES')
        scope.setTag('endpoint', '/login/share-session')
        scope.setExtras({ method: e?.config?.method, params })
        Sentry.captureException(e)
      })
    }

    return {
      code: status || 500,
      message: responseData?.message || (status === 0 ? 'Error de red' : 'Error desconocido'),
      payload: responseData,
      authValid: false,
      errorCode: responseData?.errorCode || responseData?.code || 'UNKNOWN_ERROR',
    }
  }
}
